import { MAPBOX_TOKEN } from "./map"

function sortable(items, url) {
  $('.sortable-container').sortable({
    axis: 'yx',
    containment: 'parent',
    tolerance: 'pointer',
    cursor: "move",
    items: items,
    delay: 100,
    update: function() {
      // jquery-ujs adds the CSRF token header to every jQuery ajax request
      $.ajax({
        url: url,
        type: 'POST',
        data: $('.sortable-container').sortable('serialize')
      })
    }
  })
}

if (window.cfg.page == 'works.index') {
  $(document).ready(function() {
    sortable('.col-md-4', '/works/update-order')
  })
}

if (window.cfg.page == 'works.edit' || window.cfg.page == 'works.new' || window.cfg.page == 'works.create') {
  $(document).ready(function() {
    let center
    if ($('#work_lat').val() && $('#work_lon').val()) {
      center = [$('#work_lon').val(), $('#work_lat').val()]
    } else {
      center = [19.152, 48.735277]
    }

    mapboxgl.accessToken = MAPBOX_TOKEN
    const map = new mapboxgl.Map({
      container: 'map-container',
      style: 'mapbox://styles/mapbox/streets-v11',
      center: center,
      zoom: 13
    })

    // Disable map zoom when using scroll
    map.scrollZoom.disable()

    const marker = new mapboxgl.Marker({ draggable: true })
      .setLngLat(center)
      .addTo(map)

    marker.on('dragend', function() {
      const lngLat = marker.getLngLat()
      $('#work_lon').val(lngLat.lng)
      $('#work_lat').val(lngLat.lat)
    })

    $('.js-destroy-work-attachment').on('ajax:success', function() {
      $(this).parents('.thumbnail').remove()
    })

    sortable('.thumbnail', '/work-attachments/update-order')
  })
}
